//
//

import i18n from "@/i18n/index";
import { date } from "quasar";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import { mapGetters, mapActions } from "vuex";
import { publishAppPermissions } from "@/assets/js/appFunc";
import {
    requiredUnless
} from "vuelidate/lib/validators";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQCard from "@/components/Generics/AQCard";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQHistory from "@/components/Generics/AQHistory/AQHistory.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import restore from "@/assets/images/RestoreIcon.svg";

export default {
    name: "NewApiExposedModal",
    components: {
        AQModal,
        AQButton,
        AQInput,
        AQCard,
        AQDropdown,
        AQToggle,
        AQCheckbox,
        AQTooltip,
        AQHistory,
        AQDialog
    },
    props: {
        apiItem: {
            type: Object,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            default: false
        },
        roomEmptyExposed: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            showModal: true,
            area: "",
            checked: false,
            checkedConsumed: false,
            picked: false,
            typeSelect: "WSDL",
            showConsumed: true,
            nameDuplicated: false,
            selectedTab: "tab-exposed",
            name: "",
            select: null,
            reset: false,
            exposedName: null,
            exposedClientID: null,
            exposedSecretKey: null,
            exposedDescription: null,
            errorMessage: false,
            domains: [],
            isReadonly: false,
            exposedApiSaveHistoryModal: false,
            exposedApiSaveHistoryData: [],
            exposedApiSaveHistoryCurrentPage: 0,
            exposedApiSaveHasMoreItems: true,
            exposedApisaveHActiveCommitId: null,
            keyUpdate: 0,
            standaloneTypes: new Set(["publish", "delete", "recover"]),
            dialogAction: null,
            previewMode: false,
            previewApiToast: null,
            warningExpApiDialog: false,
            previewedApiItem: null,
            mesageRestoreDialog: null,
            restoredApiData: null,
            restoreIcon: `img:${restore}`,
            expApiNoteDialog: false,
            expApiNoteDialogTitle: null,
            confirmLabel: null,
            createNote: false,
            expApiNote: null
        };
    },
    validations: {
        exposedName: {
            requiredUnless: requiredUnless(function () {
                return !this.showConsumed;
            })
        }
    },
    computed: {
        ...mapGetters("main", ["getCurrentApplicationId"]),
        ...mapGetters("apis", ["allExposedApis", "getExposedApiCommitId"]),
        ...mapGetters("apps", ["currentApp", "getCurrentAppUserPermissions", "processList"]),
        warningDialogTitle() {
            return this.dialogAction === "restore" ? this.$t("versioning.restoreDialogTitle") : this.$t("documents.wrnTitle");
        },
        createNoteDisabled() {
            return !this.expApiNote && this.createNote;
        },
        hasSave() {
            return this.previewMode || this.isReadonly ? null : {
                label: this.$t("generic.save"),
                disabled: true
            };
        },
        headerActions() {
            return this.previewMode || this.restoredApiData || this.isReadonly ? [] : [{
                label: this.$t("versioning.saveHModalTitle"),
                name: "saveH",
                disabled: false
            }];
        },
        warningDialogMessage() {
            return this.dialogAction === "restore" ? this.mesageRestoreDialog : this.$t("documents.wrnMessage");
        },
        warningDialogConfirmLabel() {
            return this.dialogAction === "restore" ? this.$t("versioning.restore") : this.$t("documents.leaveBtn");
        },
        modalTitle() {
            return this.editMode ? this.$t("diagrams.components.configApi.editExposedApiTitle")
                : this.$t("diagrams.components.configApi.addNewExposedApiTitle");
        },
        errorLabel() {
            let errorMessage = "";
            if (this.$v.exposedName.$error) {
                errorMessage = this.$t("api.nameRequired");
            } else if (this.nameDuplicated) {
                errorMessage = this.$t("api.changeName");
            }
            return errorMessage;
        }
    },
    watch: {
        roomEmptyExposed: {
            handler(newVal) {
                this.isReadonly = !newVal;
            },
            immediate: true
        }
    },
    mounted() {
        this.loadExposedApi();
    },
    created() {
        this.$root.$on("startEditing", () => {
            this.getAllExposedApis().then(exposedApis => {
                if (exposedApis.data && this.apiItem) {
                    const editedExposedApi = { ...this.allExposedApis.find(api => api.id === this.apiItem.id) };
                    this.loadExposedApi(editedExposedApi);
                }
            });
        });
        this.$root.$on("apiRenameExposedDone", renameObj => {
            if (this.apiItem && this.apiItem.id && this.apiItem.id === renameObj.editId) {
                this.exposedName = renameObj.editNewName;
            }
        });
    },
    destroyed() {
        this.$root.$off("startEditing");
        this.$root.$off("apiRenameExposedDone");
    },
    methods: {
        ...mapActions("apis", ["saveExposedApi", "addNewConsumedApi", "getAllExposedApis"]),
        ...mapActions("apps", ["getAppSettingsInfo"]),
        ...mapActions("components", ["getHistoryData", "saveDeleteNote", "getHistoryCredentialsPreviewData", "getNote"]),
        loadExposedApi(editedExposedApi) {
            if (this.editMode) {
                this.exposedName = editedExposedApi ? editedExposedApi.name : this.apiItem.name;
                this.exposedDescription = editedExposedApi ? editedExposedApi.description : this.apiItem.description;
                this.checked = editedExposedApi ? editedExposedApi.checked : this.apiItem.checked;
                this.domains = (editedExposedApi ? editedExposedApi.domains : this.apiItem.domains) || [""];
            }
        },
        modalActionSaveHistory(action) {
            if (action === "close") {
                this.exposedApiSaveHistoryModal = false;
            }
        },
        actionsDlg($event) {
            if ($event === "save") {
                if (this.exposedName) {
                    this.save();
                }
            } else if ($event === "close") {
                if (this.hasSave && !this.hasSave.disabled) {
                    this.warningExpApiDialog = true;
                } else {
                    this.resetInfoCloseModal();
                }
            } else if ($event === this.$t("versioning.saveHModalTitle")) {
                this.getSaveHistory();
            }
        },
        resetInfoCloseModal() {
            this.$emit("editMode", false);
            this.$emit("input", false);
            this.dialogAction = null;
            this.restoredApiData = null;
            this.previewedApiItem = null;
            this.closePreviewToast();
        },
        restoreExpApi() {
            this.dialogAction = "restore";
            this.warningExpApiDialog = true;
            this.restoredApiData = this.previewedApiItem;
            this.mesageRestoreDialog = this.$t("versioning.restoreDialogInfo", { interfaceName: this.apiItem ? this.apiItem.name : this.name,
                date: this.dateFormatter(this.restoredApiData.timestamp) });
        },
        dialogConfirmAction(actionMessage) {
            if (actionMessage === "ok") {
                if (this.exposedApiSaveHistoryModal && !this.dialogAction) { // if user clicks on api timeline Item
                    this.previewApiAction();
                } else if (this.dialogAction === "restore") { // if user clicks on restore three dotted menu option or restore button
                    this.closePreviewToast();
                    if ((this.previewMode && this.restoredApiData && this.restoredApiData !== this.previewedApiItem) || !this.previewMode) {
                        // if user in in previewMode and then clicks to restore
                        // another item than previewed one or user isn't in preview mode
                        this.previewApiAction(true);
                    }
                    this.previewMode = false;
                    this.exposedApiSaveHistoryModal = false;
                    this.enableSave();
                    this.dialogAction = null;
                    setTimeout(() => {
                        this.exposedApisaveHActiveCommitId = null;
                    }, 500);
                } else { // if user clicks on x add/edit api modal
                    this.resetInfoCloseModal();
                }
            } else if (this.exposedApiSaveHistoryModal) { // action === cancel and saveHmodal is opened
                this.warningExpApiDialog = false;
            } else { // action === cancel then user clicks on close add/edit api modal
                this.$emit("input", true);
            }
        },
        enableSave() {
            this.hasSave.disabled = false;
        },
        save() {
            if (this.hasSave) {
                this.hasSave.disabled = true;
            }
            const item = {
                id: this.editMode ? this.apiItem.id : null,
                name: this.exposedName,
                description: this.exposedDescription,
                applicationId: this.getCurrentApplicationId,
                domains: this.domains,
                checked: this.checked,
                active: true
            };
            this.nameDuplicated = !!this.allExposedApis.find(
                elem => elem.name === item.name && elem.id !== item.id
            );
            if (this.editMode) {
                if (this.nameDuplicated) {
                    this.enableSave();
                } else {
                    const currentExpApiCommitId = this.getExposedApiCommitId || this.apiItem.commitId;
                    item.commitId = this.getExposedApiCommitId || currentExpApiCommitId;
                    this.saveExposedApi(item).then(data => {
                        this.showPublishBtn();
                        const updatedExposedToSet = {
                            applicationId: data.data.applicationId,
                            active: data.data.active,
                            name: item.name,
                            description: item.description,
                            checked: item.checked,
                            domains: item.domains ? item.domains : this.domains,
                            id: data.data.id,
                            commitId: data.data.commitId
                        };
                        this.$store.commit("main/setInterfaceDirty", false);
                        this.$root.$emit("showCheckedSaveBtn", false);
                        this.showDlg = false;
                        this.$store.commit("apis/setUpdatedExposedApi", updatedExposedToSet);
                        this.$emit("input", false);
                        this.$emit("editMode", false);
                        this.$toast.showNotify({
                            message: this.$t("generic.savedSuccessfully"),
                            type: "success",
                            timeout: 500,
                            icon: "check"
                        });
                    }, () => {
                        this.$toast.showNotify({
                            message: this.$t("generic.saveUnsuccessful"),
                            type: "error",
                            timeout: 1000,
                            icon: "close"
                        });
                    });
                }
            } else if (this.nameDuplicated) {
                this.enableSave();
            } else {
                this.saveExposedApi(item).then(data => {
                    this.showPublishBtn();
                    const exposedToSet = {
                        applicationId: data.data.applicationId,
                        active: data.data.active,
                        name: item.name,
                        description: item.description,
                        domains: data.data.domains,
                        checked: this.checked,
                        id: data.data.id
                    };
                    this.$store.commit("main/setInterfaceDirty", false);
                    this.$store.commit("apis/setExposedApiCommitId", data.data.commitId);
                    this.$store.commit("apis/setNewExposedApi", exposedToSet);
                    this.showModal = false;
                    this.enableSave();
                    this.$root.$emit("showCheckedSaveBtn", false);
                    this.$emit("input", false);
                    this.$toast.showNotify({
                        message: this.$t("generic.savedSuccessfully"),
                        type: "success",
                        timeout: 500,
                        icon: "check"
                    });
                },
                () => {
                    this.$toast.showNotify({
                        message: this.$t("generic.saveUnsuccessful"),
                        type: "error",
                        timeout: 1000,
                        icon: "close"
                    });
                    this.enableSave();
                });
            }
        },
        addRow() {
            if (!this.isReadonly) {
                this.domains.push("");
            }
        },
        deleteRow(index) {
            if (!this.isReadonly) {
                this.domains.splice(index, 1);
                this.enableSave();
            }
        },
        showPublishBtn() {
            this.getAppSettingsInfo(this.currentApp).then(data => {
                this.currentApp.publishStatus = data.data.publishStatus;
                this.$store.commit("apps/setCurrentApp", this.currentApp);
                this.$root.$emit("showPublish", {
                    noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses") ? !this.currentApp.nrOfProcesses : !this.processList.length,
                    showPublish: publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions)
                });
            });
        },
        getSaveHistory() {
            if (this.exposedApiSaveHasMoreItems && this.editMode) {
                const payload = {
                    searchType: "SAVE_HISTORY",
                    module: "APICredentials",
                    applicationId: this.getCurrentApplicationId,
                    elementId: this.apiItem.id,
                    page: this.exposedApiSaveHistoryCurrentPage,
                    size: 10
                };
                this.getHistoryData(payload).then(data => {
                    if (data && data.data && data.data.history) {
                        this.exposedApiSaveHistoryData = this.exposedApiSaveHistoryData.concat(data.data.history);
                        this.exposedApiSaveHasMoreItems = data.data.hasMorePages;
                    }
                    this.exposedApiSaveHistoryModal = true;
                });
            } else {
                this.exposedApiSaveHistoryModal = true;
            }
        },
        historyMenuClick(evt) {
            this.dialogAction = evt.actionName;
            if (this.dialogAction === "restore") {
                this.warningExpApiDialog = true;
                this.mesageRestoreDialog = this.$t("versioning.restoreDialogInfo", { interfaceName: this.apiItem ? this.apiItem.name : this.name,
                    date: this.dateFormatter(evt.timelineItem.timestamp) });
                this.restoredApiData = evt && evt.timelineItem ? evt.timelineItem : this.previewedApiItem;
            }
        },
        closePreviewToast() {
            if (this.previewApiToast) {
                this.previewApiToast();
            }
        },
        closePreviewMode() {
            this.previewMode = false;
            this.closePreviewToast();
            this.exposedApisaveHActiveCommitId = null;
            this.loadExposedApi();
        },
        previewApi(evt) {
            this.previewedApiItem = evt;
            const isSamePreview = this.exposedApisaveHActiveCommitId ? this.exposedApisaveHActiveCommitId === evt.commitId : false;
            if (!this.standaloneTypes.has(evt.commitType) && !isSamePreview) {
                if (!this.previewMode && !this.hasSave.disabled) {
                    this.warningExpApiDialog = true;
                } else {
                    this.previewApiAction();
                }
            }
        },
        previewApiAction(fromRestore) {
            const timelineItem = fromRestore ? this.restoredApiData : this.previewedApiItem;
            if (!this.standaloneTypes.has(timelineItem.commitType)) {
                const payload = {
                    module: "APICredentials",
                    applicationId: this.getCurrentApplicationId,
                    elementId: this.apiItem.id,
                    commitId: timelineItem.commitId
                };
                this.getHistoryCredentialsPreviewData(payload).then(data => {
                    if (data && data.data) {
                        data.data.name = this.apiItem.name;
                        this.loadExposedApi(data.data);
                        this.exposedApisaveHActiveCommitId = data.data.commitId;
                        this.previewMode = !fromRestore;
                        this.showModal = true;
                        if (!fromRestore) {
                            this.previewApiToast = this.$toast.showNotify({
                                type: "info",
                                message: `${i18n.t("versioning.previewToastTitle")} ${this.dateFormatter(this.previewedApiItem.timestamp)}`,
                                caption: this.$t("versioning.previewToastText"),
                                code: "preview-ui",
                                timeout: 30000000
                            });
                        }
                    }
                });
            }
        },
        getNoteData() {
            if (this.previewedApiItem) {
                const payload = {
                    module: "APICredentials",
                    applicationId: this.getCurrentApplicationId,
                    elementId: this.apiItem.id,
                    commitId: this.previewedApiItem.commitId
                };
                this.getNote(payload).then(data => {
                    if (data) {
                        this.expApiNote = data.data;
                        this.createNote = !this.expApiNote;
                        this.confirmLabel = this.expApiNote ? this.$t("versioning.updateNote") : this.$t("versioning.createNote");
                        this.expApiNoteDialogTitle = this.expApiNote
                            ? this.$t("versioning.dialogTitleEdit", { date: `${this.dateFormatter(this.previewedApiItem.timestamp)}` })
                            : this.$t("versioning.dialogTitleCreate", { date: `${this.dateFormatter(this.previewedApiItem.timestamp)}` });
                    }
                    this.expApiNoteDialog = true;
                });
            }
        },
        actionNote(noteData) {
            const payload = {
                module: "APICredentials",
                applicationId: this.getCurrentApplicationId,
                elementId: this.apiItem.id
            };
            payload.commitId = noteData ? noteData.timelineItem.commitId : this.previewedApiItem.commitId;
            payload.note = noteData ? noteData.note : this.expApiNote;
            let messageLabel = "";
            if (noteData) {
                messageLabel = this.dialogAction === "edit" ? this.$t("versioning.updateNoteDialog")
                    : this.$t("versioning.saveNote");
            } else {
                messageLabel = this.confirmLabel === this.$t("api.update") ? this.$t("versioning.updateNoteDialog") : this.$t("versioning.saveNote");
            }
            this.saveDeleteNote(payload).then((data) => {
                if (data) {
                    this.$toast.showNotify({
                        type: "success",
                        message: messageLabel,
                        timeout: 500,
                        hasClose: true
                    });
                    if (noteData) {
                        noteData.timelineItem.note = noteData.note;
                        this.keyUpdate += 1;
                    } else if (this.previewedApiItem) {
                        this.previewedApiItem.note = this.expApiNote;
                    }
                }
            },
            err => { console.log("error", err); });
        },
        dateFormatter(dateToFormat) {
            const newData = dateToFormat ? date.formatDate(dateToFormat, APP_DATE_DOT_FORMAT).split(".") : "";
            const data = new Date();
            data.setMonth(newData[1] - 1);
            const year = newData[2].split(" ")[0];
            const hour = newData[2].split(" ")[1].substring(0, 5);
            return `${data.toLocaleString("en-US", { month: "long" })} ${newData[0]}, ${year}  ${i18n.t("versioning.at")} ${hour}`;
        }
    }
};
